module.exports = __webpack_public_path__ + "static/media/COS_WELEDA.827bce18.jpg";